import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-developers',
  templateUrl: './new-developers.component.html',
  styleUrls: ['./new-developers.component.scss']
})
export class NewDevelopersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
